export const landingTrackerServiceModule = angular
  .module('Q.services.tracker-service', [])
  .factory('trackerService', function ($window) {
    return {
      trackEvent(event, props) {
        if ($window.analytics && $window.analytics.track) {
          $window.analytics.track(
            event,
            angular.extend({ app: 'Landing' }, props || {}),
          );
        }
      },
    };
  });
